/**
 * @generated SignedSource<<105b64ef62ecd2b078af68ae8fd0596c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Dac8QuestionType = "SINGLE_CHOICE";
export type Dac8QuestionsListInput = {
  residenceCountry: string;
  taxCountry: string;
};
export type Dac8QuestionsViewQuery$variables = {
  input?: Dac8QuestionsListInput | null | undefined;
};
export type Dac8QuestionsViewQuery$data = {
  readonly dac8Questions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly answers: ReadonlyArray<{
          readonly answer: string;
          readonly id: string;
          readonly translationKey: string;
        }>;
        readonly id: string;
        readonly question: string;
        readonly translationKey: string;
        readonly type: Dac8QuestionType;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type Dac8QuestionsViewQuery = {
  response: Dac8QuestionsViewQuery$data;
  variables: Dac8QuestionsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "translationKey",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Dac8QuestionsConnection",
    "kind": "LinkedField",
    "name": "dac8Questions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Dac8QuestionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Dac8Question",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "question",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Dac8Answer",
                "kind": "LinkedField",
                "name": "answers",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answer",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Dac8QuestionsViewQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Dac8QuestionsViewQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "8ad0d163ec32c3627975fd23645cfe3a",
    "id": null,
    "metadata": {},
    "name": "Dac8QuestionsViewQuery",
    "operationKind": "query",
    "text": "query Dac8QuestionsViewQuery(\n  $input: Dac8QuestionsListInput\n) {\n  dac8Questions(input: $input) {\n    edges {\n      node {\n        id\n        question\n        translationKey\n        type\n        answers {\n          id\n          answer\n          translationKey\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ee38dd8b201361e794c28c50c4fa0a1";

export default node;
